export const menuItemsInfo = [
  {
    itemId: "menu-item-home",
    itemText: "home",
    redirectTo: "/dashboard",
    collapsable: false,
    permission: ""
  },
  // Hide resources tab until re-design is done
  // {
  //   itemId: "menu-item-resources",
  //   itemText: "resources",
  //   redirectTo: "/resources",
  //   collapsable: false,
  //   permission: "onboarding"
  // },
  {
    itemId: "menu-item-appointments",
    itemText: "appointments",
    redirectTo: "",
    collapsable: true,
    subMenuItems: [
      {
        itemId: "menu-item-appointments-submenu-my-appointments",
        itemText: "myAppointments",
        redirectTo: "/upcoming-chats"
      },
      {
        itemId: "menu-item-appointments-submenu-schedule",
        itemText: "scheduleNew",
        redirectTo: "/schedule-chat"
      },
      {
        itemId: "menu-item-appointments-submenu-history",
        itemText: "history",
        redirectTo: "/video-chat-history"
      }
    ],
    permission: "scheduleChat"
  },
  {
    itemId: "menu-item-orders",
    itemText: "orders",
    redirectTo: "",
    collapsable: true,
    subMenuItems: [
      {
        itemId: "menu-item-orders-submenu-my-orders",
        itemText: "myOrders",
        redirectTo: "/orders",
        permission: "myOrders"
      },
      {
        itemId: "menu-item-orders-submenu-order",
        itemText: "orderSupplies",
        redirectTo: "/supplies",
        permission: "orderSupplies"
      },
      {
        itemId: "menu-item-orders-submenu-tracking",
        itemText: "tracking",
        redirectTo: "/tracking",
        permission: "tracking"
      }
    ]
  },
  {
    itemId: "menu-item-documents",
    itemText: "documents",
    redirectTo: "",
    collapsable: true,
    subMenuItems: [
      {
        itemId: "menu-item-documents-submenu-my-documents",
        itemText: "myDocuments",
        redirectTo: "/documents",
        permission: "documents"
      },
      {
        itemId: "menu-item-documents-submenu-questionnaires",
        itemText: "questionnaires",
        redirectTo: "/questionnaires",
        permission: "questionaires"
      },
      {
        itemId: "menu-item-documents-submenu-signature",
        itemText: "signature",
        redirectTo: "/signatures",
        permission: "signatures"
      }
    ]
  },
  {
    itemId: "menu-item-profile",
    itemText: "myProfile",
    redirectTo: "",
    permission: "myProfile",
    collapsable: true,
    subMenuItems: [
      {
        itemId: "menu-item-documents-submenu-my-info",
        itemText: "myInfo",
        redirectTo: "/profile"
      },
      {
        itemId: "menu-item-documents-submenu-notifications",
        itemText: "notificationSettings",
        redirectTo: "/notification-settings"
      }
    ]
  },
  {
    itemId: "menu-item-live-chat",
    itemText: "liveChat",
    redirectTo: "/chat-now",
    collapsable: false,
    permission: "chatNow"
  },
  {
    itemId: "menu-item-logout",
    itemText: "logout",
    redirectTo: "",
    collapsable: false,
    permission: ""
  }
];

export const filterItems = appPermissions => {
  const filteredItems = [];
  menuItemsInfo.forEach(i => {
    if (i.itemText === "myProfile") {
      filteredItems.push(i);
    } else {
      if (!i.collapsable || i.permission === "scheduleChat") {
        if (i.permission === "" || appPermissions[i.permission])
          filteredItems.push(i);
      } else {
        let subMenu = [];
        i.subMenuItems.forEach(si => {
          if (appPermissions[si.permission]) subMenu.push(si);
        });
        i.subMenuItems = subMenu;
        if (subMenu.length > 0) filteredItems.push(i);
      }
    }
  });
  return filteredItems;
};
